import { render, staticRenderFns } from "./SKDataTableMultiselect.vue?vue&type=template&id=4281f646&"
import script from "./SKDataTableMultiselect.vue?vue&type=script&lang=js&"
export * from "./SKDataTableMultiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports